export interface ChartFilterType {
  vlanranges: any;
  connection: any;
  port?: any;
}

export interface MalfunctionFilterType {
  loadMoreActive: boolean;
  hasMore: boolean;
  filterStartDate: any;
  filterEndDate: any;
  productType: any;
  subscriptionId: any;
  subscriptionName: string;
}

export interface MalfunctionDateChangeType {
  filterDate: Date;
}

export interface SlsDialogPayload {
  subscription: any;
}

export type NotificationSetting = "Down" | "Loss of Resiliency" | "Reduced Redundancy" | "Never";

export interface NWDMaintenanceBanner {
  enabled: boolean;
  title?: string;
  contents?: string;
}

export interface NWDUserConfig {
  oauthEnabled: boolean;
  oauthAuthorizeUrl: string;
  clientId: string;
  redirectUri: string;
  wellKnownUrl: string;
  issuer: string;
  loa: string;
  maintenanceBanner: NWDMaintenanceBanner;
  selfServiceEnabled: boolean;
  userInterviewEnabled: boolean;
}

export const EMPTY_CONFIGURATION: NWDUserConfig = {
  oauthEnabled: true,
  oauthAuthorizeUrl: "",
  clientId: "",
  redirectUri: "",
  wellKnownUrl: "",
  issuer: "",
  loa: "",
  maintenanceBanner: {
    enabled: false,
    title: "",
    contents: "",
  },
  selfServiceEnabled: false,
  userInterviewEnabled: false,
};

export interface OidcTokenResult {
  exp: number;
  iat: number;
  auth_time: number;
  jti: string;
  iss: string;
  aud: string;
  sub: string;
  typ: string;
  azp: string;
  nonce: string;
  sid: string;
  at_hash: string;
  acr: string;
  email_verified: boolean;
  user_name: string;
  name: string;
  preferred_username: string;
  given_name: string;
  authenticating_authority: string;
  family_name: string;
  eduperson_entitlement: string[];
  email: string;
}

export interface NWDUser {
  authenticatingAuthority: string;
  authorities: string[];
  displayName: string;
  eduPersonPrincipalName: string;
  email: string;
  customerId: string | null;
  organizationName: string;
  organizationHasIcp: boolean;
  teams: string[];
  roles: string[];
  inviteCustomerIds?: string[];
}

export interface IFilter {
  type: string;
  value: string;
}

export const EMPTY_USER = {
  authenticatingAuthority: "",
  authorities: [],
  displayName: "",
  eduPersonPrincipalName: "",
  email: "",
  customerId: "",
  organizationName: "",
  organizationHasIcp: false,
  teams: [],
  roles: [],
};
